<template>
  <div class="popup-box flex flex-column" style="position: relative">
    <ul class="form-box">
      <el-form
        :model="state.model"
        ref="formDom"
        label-position="top"
        style="width: 100%"
        label-suffix="："
      >
        <el-form-item label="员工姓名">
          {{ state.model?.name }}
        </el-form-item>
        <el-form-item label="手机号">
          {{ state.model?.phone }}
        </el-form-item>
        <el-form-item label="证件号">
          {{ state.model?.idcard }}
        </el-form-item>
        <el-form-item
          label="减免事项"
          prop="jmsx"
          :rules="[
            {
              required: true,
              message: '请填写供应商名称',
              trigger: 'blur',
            },
          ]"
        >
          <el-select
            v-model="state.model.jmsx"
            placeholder="请选择"
            style="width: 200px"
          >
            <el-option
              v-for="item in state.secondary_data"
              :label="item.jmsxmc"
              :value="item.jmsxmc"
              :key="item"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="减免性质"
          prop="jmxz"
          :rules="[
            {
              required: true,
              message: '请填写供应商名称',
              trigger: 'blur',
            },
          ]"
        >
          <el-select
            v-model="state.model.jmxz"
            placeholder="请选择"
            style="width: 200px"
          >
            <el-option label="Zone one" value="shanghai" />
            <el-option label="Zone two" value="beijing" />
          </el-select>
        </el-form-item>
      </el-form>
    </ul>
    <ul class="submit-box" style="box-shadow: none">
      <el-button type="primary" @click="onSubmit">提交</el-button>
    </ul>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { taxdeclare_editattached } from "@/http/supplier";
import { post_response } from "@/utils/qFormat";
import { secondary_select } from "@/http/dictionary";

export default {
  props: {
    item: Object,
    attached_type: String,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: {},
    });
    onMounted(() => {
      state.model = props.item;

      secondary_select({
        fblx:
          props.attached_type == "mssd"
            ? "免税附表"
            : props.attached_type == "jmse"
            ? "减免附表"
            : "",
        sdlxfb:
          props.item?.declare_type == 1
            ? "zhsdfb"
            : props.item?.declare_type == 2
            ? "flsdfb"
            : props.item?.declare_type == 3
            ? "fjmsdfb"
            : "",
        sdlxmc: props.item?.declare_item,
      }).then((res) => {
        if (res.status == 200) state.secondary_data = res.data.data;
      });
    });

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          taxdeclare_editattached(state.model).then((res) => {
            post_response(res, emit);
          });
        }
      });
    };
    return {
      state,
      formDom,
      onSubmit,
    };
  },
};
</script>
<style scoped lang="less"></style>
